import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon
} from "lucide-react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

/**
 * Toast surface styles:
 * - soft semantic tints (error is muted rose, not pure red)
 * - matches ops visual foundation / enterprise calm
 */
function Toaster(props: ToasterProps) {
  return (
    <Sonner
      theme="light"
      richColors
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
          /* Soft rose — readable as error, not alarm-red. */
          "--error-bg": "oklch(0.965 0.02 22)",
          "--error-border": "oklch(0.88 0.045 22)",
          "--error-text": "oklch(0.42 0.12 25)",
          /* Quiet green for success. */
          "--success-bg": "oklch(0.97 0.02 155)",
          "--success-border": "oklch(0.9 0.04 155)",
          "--success-text": "oklch(0.4 0.1 155)",
          /* Soft amber for warnings. */
          "--warning-bg": "oklch(0.975 0.025 85)",
          "--warning-border": "oklch(0.9 0.05 75)",
          "--warning-text": "oklch(0.45 0.1 55)",
          /* Calm blue for info. */
          "--info-bg": "oklch(0.97 0.015 244)",
          "--info-border": "oklch(0.9 0.03 244)",
          "--info-text": "oklch(0.42 0.1 244)"
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster };
